import type { DataTableDesignTokens, DataTableTokenSections } from '@primeuix/themes/types/datatable';

// Brand guide: p-table on role tokens — page-surface header, content hairlines,
// orange selected rows. Previously p-table had no token file at all.
export const headerCell: DataTableTokenSections.HeaderCell = {
    background: '{extend.surfacepage}',
    borderColor: '{content.borderColor}',
    color: '{text.color}',
    hoverBackground: '{content.hoverBackground}',
    padding: '12px 14px',
    gap: '8px'
};

export const bodyCell: DataTableTokenSections.BodyCell = {
    borderColor: '{content.borderColor}',
    padding: '12px 14px'
};

export const footerCell: DataTableTokenSections.FooterCell = {
    borderColor: '{content.borderColor}',
    padding: '12px 14px'
};

export const columnTitle: DataTableTokenSections.ColumnTitle = {
    fontWeight: '600'
};

export const row: DataTableTokenSections.Row = {
    background: '{content.background}',
    hoverBackground: '{content.hoverBackground}',
    selectedBackground: '{highlight.background}',
    color: '{text.color}',
    hoverColor: '{text.hoverColor}',
    selectedColor: '{highlight.color}'
};

export const root: DataTableTokenSections.Root = {
    borderColor: '{content.borderColor}'
};

export const colorScheme: DataTableTokenSections.ColorScheme = {
    light: {
        headerCell: {
            background: '{extend.surfacepage}',
            borderColor: '{content.borderColor}',
            color: '{text.color}',
            hoverBackground: '{content.hoverBackground}'
        },
        bodyCell: {
            borderColor: '{content.borderColor}'
        },
        row: {
            background: '{content.background}',
            hoverBackground: '{content.hoverBackground}',
            selectedBackground: '{highlight.background}',
            color: '{text.color}',
            selectedColor: '{highlight.color}'
        }
    }
};

export default {
    root,
    headerCell,
    columnTitle,
    row,
    bodyCell,
    footerCell,
    colorScheme
} satisfies DataTableDesignTokens;
